<template>
    <a-modal width="85%" title="查看详情" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose">
        <template #footer>
            <a-button key="back" @click="onClose">取消</a-button>
        </template>
        <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="id" name="id">
                    <a-input v-model:value="form.id" />
                </a-form-item>
            </div>
            <div>
                <a-row :gutter="[24, 8]" v-if="form.isLoad ==='1'">
                    <a-col :span="24">
                        <a-form-item name="enterpriseFinanceDemandLoadList">
                            <a-descriptions title="往期贷款情况" :column="2">
                                <a-descriptions-item label="有无贷款情况">{{ form.isLoad ==='1'?'有':'无' }}</a-descriptions-item>
                            </a-descriptions>
                            <a-table :columns="columns" :data-source="form.enterpriseFinanceDemandLoadList" bordered :pagination="false">
                                <template #customTitle1>
                                    <div>
                                        <span style="color: #ff4d4f;">*</span> 合作银行
                                    </div>
                                </template>
                                <template #customTitle2>
                                    <div>
                                        <span style="color: #ff4d4f;">*</span> 贷款额度（万元）
                                    </div>
                                </template>
                                <template #customTitle3>
                                    <div>
                                        <span style="color: #ff4d4f;">*</span> 利率
                                    </div>
                                </template>
                                <template #loadAmount="{ record }">
                                    <span>{{record.loadAmount}}</span>
                                </template>
                                <template #loadBank="{ text }">
                                    <DictRender :dict-obj="dictObjs['intentionbank']" :text="text" />
                                </template>
                                <template #loadBankname="{ record }">
                                    <span>{{record.loadBankname}}</span>
                                </template>
                                <template #loadRate="{ record }">
                                    <span>{{record.loadRate}}</span>
                                </template>
                            </a-table>
                        </a-form-item>
                    </a-col>
                </a-row>
            </div>
            <div>
                <a-descriptions title="金融需求情况"  :column="2">
                    <a-descriptions-item label="有无贷款需求">{{ form.isDemand ==='1'?'有':'无' }}</a-descriptions-item>
                    <a-descriptions-item v-if="form.isDemand==='1'" label="贷款意向额度（万元）">{{ form.intentionAmount }}</a-descriptions-item>
                    <a-descriptions-item v-if="form.isDemand==='1'" label="合作银行">
                        <dict-render :dict-obj= "dictObjs['intentionbank']" :text="form.intentionBank"></dict-render>
                    </a-descriptions-item>
                    <a-descriptions-item v-if="form.isDemand==='1'" label="其他银行名称">{{ form.intentionBankname }}</a-descriptions-item>
                    <a-descriptions-item v-if="form.isDemand==='1'" label="期望利率(%)">{{ form.intentionRate }}</a-descriptions-item>


<!--                    <a-col :span="12" v-if="form.isDemand==='1'">-->
<!--                        <a-form-item label="合作银行（可多选）" name="intentionBank">-->
<!--                            <DictSelect @update:value="intentionBankChange" multiple="true"  v-model:value="form.intentionBank" :dict-name="'intentionbank'" placeholder="请选择" />-->
<!--                        </a-form-item>-->
<!--                    </a-col>-->
                </a-descriptions>
            </div>
        </a-form>
    </a-modal>
</template>
<script>
import { formMixin, dictMixin } from "@/mixins";
import { sys_policy,} from "@/api/policyService";
import DictRender from "@/components/other/DictRender";
import { policy, dateFormat } from "@/config/variableConfig";
import { message } from "ant-design-vue";
import { ls } from "@/utils/util";
import { file_service } from "@/api/adminService";
import axios from "axios";

const columns = [
    {dataIndex: "loadBank",width:240, slots: {title: 'customTitle1',customRender: "loadBank"}},
    {dataIndex: "loadBankname",title:'其他银行名称', slots: {customRender: "loadBankname"}},
    {dataIndex: "loadAmount", slots: {title: 'customTitle2',customRender: "loadAmount"}},
    {dataIndex: "loadRate",slots: {title: 'customTitle3',customRender: "loadRate"}},
];
export default {
    name: "DetailModal",
    components: {DictRender },
    mixins: [formMixin, dictMixin],
    data() {
        return {
            obs: false,
            dictNames: 'intentionbank',
            columns,
            policy,
            dateFormat,
            isAllowVisible: false,
            form: {
                id: null,
                enterpriseFundExpenditureList: []
            },
            editableData: {},
            rules: {
            },
            submitType: 'json'
        }
    },
    methods: {

        handleOk() {
            this.$router.push({ path: '/sys/manage' })
        },
        resetForm() {
            this.$refs.ruleForm.resetFields('year')
        },
        getMoban() {
            if (this.form.year) {
                this.postAction({
                    url: sys_policy.getMoban,
                    params: { cashingTypeValue: '0', year: this.form.year }
                }).then(res => {
                    this.fileDowload(res)
                })
            } else {
                message.warning('请选择年份！')
            }
        },
        fileDowload(r) {
            if (r) {
                let name = r.split('|')[1];
                axios({
                    methods: 'get',
                    url: file_service.download + r,
                    responseType: 'blob',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded',
                        Authorization: 'Bearer' + ls.get('token') || ''
                    }
                }).then(data => {
                    const blob = new Blob([data.data], { type: "application/vnd.ms-excel;charset=utf-8" });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement("a"); // 创建a标签
                    link.href = url;
                    link.download = decodeURIComponent(name);// 文件重命名，若无需重命名，将该行删去
                    link.click();
                    URL.revokeObjectURL(url); // 释放内存
                })
            } else {
                message.warning('请确认承诺书是否已经上传！')
            }
        },
        handleAdd() {
            const newData = {
                sortNum: this.form.enterpriseFundExpenditureList ? this.form.enterpriseFundExpenditureList.length + 1 : 1,
                amount: '',
                supplyUnit: '',
                remark: '',
            }
            this.form.enterpriseFundExpenditureList.push(newData)
        },
        deleteLine(key) {
            this.form.enterpriseFundExpenditureList = this.form.enterpriseFundExpenditureList.filter(item => item.sortNum !== key);
        },
        changeData(record) {
            if (record.intellectualPropertyType == '1' || record.intellectualPropertyType == '3') {
                delete record.otherFile1
                delete record.otherFile2
            }
        },
        onSubmitFun() {
            this.form.isSubmit = 1
            this.onSubmit()
        }
    },
    watch: {
        visible: {
            handler(oldValue) {
                if (this.form.yearArr.length == 1) {
                    if (oldValue) {
                        this.getIsAllowData(this.form.year)
                    }
                }
            },
        }
    }
}
</script>
<style scoped lang="less">
:deep(.ant-table-body) {
    //min-height: 300px;
}

:deep(.ant-table-placeholder) {
    display: none;
}
.title-01{
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
}
</style>

